<span class="cw-link" (click)="prepareNavigationToEntity()">{{ 'GENERAL.NAVIGATETOCLEARING' | translate }}</span>
